import { render, staticRenderFns } from "./updatePasswordForm.vue?vue&type=template&id=c826242e&scoped=true"
import script from "./updatePasswordForm.vue?vue&type=script&lang=js"
export * from "./updatePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./updatePasswordForm.vue?vue&type=style&index=0&id=c826242e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c826242e",
  null
  
)

export default component.exports